module.exports = __webpack_public_path__ + "static/uncovering-memories-from-world-war-ii-62ef0799929dcdaf2d2615173956977f.jpg";